import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { DateService } from '../services/date.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';

@Component({
  selector: 'app-avt-liste-machine-reservation',
  templateUrl: './avt-liste-machine-reservation.component.html',
  styleUrls: ['./avt-liste-machine-reservation.component.scss']
})
export class AvtListeMachineReservationComponent implements OnInit {

  constructor(public generalService : GeneralService, public route : ActivatedRoute,public router : Router,public dateService : DateService) { }
  exist : boolean = false;
  selectedPerso_Matricule : string;
  listeCollaborateurs : Array<any> = [];
  fenetre : string = "";
  @ViewChild("listeReservationComponen", {static : false}) listeReservationComponen : AvtListesComponent;
  columns = 
  {
    "TableRD":
    [
      {"TableRE_Code":"","TableRD_Champs":"Machine_Lib","Lg_Code":"","TableRD_Des":"Equipement","TableRD_Largeur":100,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":0,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"DateDebut","Lg_Code":"","TableRD_Des":"Date","TableRD_Largeur":100,"TableRD_ReadOnly":true,"TableRD_Format":"dd-MM-yyyy","TableRD_Alligement":0,"TableRD_Ordre":0,"TableRD_Type":4,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"HeureDebutAm","Lg_Code":"","TableRD_Des":"H.Debut Am","TableRD_Largeur":100,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":0,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"HeureFinAm","Lg_Code":"","TableRD_Des":"H.Fin Am","TableRD_Largeur":100,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":0,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"HeureDebutPm","Lg_Code":"","TableRD_Des":"H.Debut Pm","TableRD_Largeur":100,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":0,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"HeureFinPm","Lg_Code":"","TableRD_Des":"H.Fin Pm","TableRD_Largeur":100,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":0,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"commentaire","Lg_Code":"","TableRD_Des":"Commentaire","TableRD_Largeur":300,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":0,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
    ]
  }
  ngOnInit() 
  {
    this.readParamUrl();
  }
  init()
  {
    this.setCollaborateur();
  }
  afficherListeReservation()
  {
    this.exist = false
    this.generalService.rechercheTable("recherche/tbdata?tablere=avtReservationEquip&param=" + this.selectedPerso_Matricule).subscribe(data =>
    {
      data = this.formaterTimeListeReservationComponen(data)
      this.listeReservationComponen.setDataSource(data)
      this.exist = true;
    });
  }
  formaterTimeListeReservationComponen(listeReervation)
  {
    listeReervation.forEach(reservation =>
    {
      var HeureDebutAm = this.dateService.setFormaTime(reservation["HeureDebutAm"])
      reservation["HeureDebutAm"] = (HeureDebutAm != "00:00" ? HeureDebutAm : ""); 
      
      var HeureFinAm = this.dateService.setFormaTime(reservation["HeureFinAm"])
      reservation["HeureFinAm"] = (HeureFinAm != "00:00" ? HeureFinAm : "")  
      
      var HeureDebutPm = this.dateService.setFormaTime(reservation["HeureDebutPm"]) 
      reservation["HeureDebutPm"] = (HeureDebutPm != "00:00" ? HeureDebutPm : "") 

      var HeureFinPm = this.dateService.setFormaTime(reservation["HeureFinPm"])  
      reservation["HeureFinPm"] = (HeureFinPm != "00:00" ? HeureFinPm : "") 
    });
    return listeReervation
  }
  setCollaborateur()
  {
    if(this.generalService.isNotEmpty(this.generalService.collaborateurConnecter))
      this.generalService.rechercheTable(this.generalService.url+"avtperso&param=0").subscribe(data =>
      {
        // 1 reservation par collaborateur
        if(this.fenetre == "1")
          this.listeCollaborateurs = data;
        // 0 reservation collaborateur connecter
        if(this.fenetre == "0")
        { 
          this.listeCollaborateurs = [data.find(col => {return col.Perso_Matricule == this.generalService.collaborateurConnecter})];        
        }
        if(this.listeCollaborateurs.length >0) 
        {
          this.listeCollaborateurs = this.generalService.sort(this.listeCollaborateurs,"Perso_Nom")
          this.selectedPerso_Matricule =  this.listeCollaborateurs[0].Perso_Matricule;
          this.afficherListeReservation();
        }
        else
        this.exist = true
      });
    else
      setTimeout(() => 
      {
        this.setCollaborateur();        
      }, 100);
  }
  goToReservationMachine(mode)
  {
    var url;
    if(mode == "MODE_AJOUT")
      url = "/w/avt/reservation/machine"
    if(mode == "MODE_MODIFIER")
      url = "/w/avt/reservation/machine";
    var windows = this.generalService.popupCenter(url)
    windows.onbeforeunload = ()=>
    {
      this.afficherListeReservation();
    }  
  }
  supprimer()
  {
    const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(AvtDialogDeleteComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result =>
      {
        if(result == "supprimer")
        {
          var deleteFn = this.generalService.supprimerSanMsgConfirm(this.listeReservationComponen.row.id,"avtReservationEquip");
          if(deleteFn != null)
          {
            this.exist = false;
            deleteFn.subscribe(data => 
            {
              this.generalService.dialogSuccess("Supprimer",true);
              this.afficherListeReservation()
            },()=>
            {
              this.exist = true;
              this.generalService.dialogSuccess("Non supprimer",false);
            })
          }
        }
      })
  }
  readParamUrl()
  {
    this.route.params.subscribe(params => 
    {
      this.fenetre = params["fenetre"];
      this.init();
    });
  }
}
